const homeMap = {
  // 获取首页banner数据
  getHomeBanner: '/usb/uwb-app/api/v1/share/listBanner',
  //   获取首页新人数据
  getHomeActivity: '/usb/uwb-app/api/v1/share/recommend',
  //   获取首页类目数据
  getHomeCategory: '/usb/uwb-app/api/v1/share/tags/productList',
  //   获取首页类目数据名字
  getHomeCategoryName: '/usb/uwb-app/api/v1/share/tags',
};

export default homeMap;
